import React, { Component } from 'react'

export default class RoleResetPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rolesType: [
                { assign: "sio", name: "Industry Admin", value: false, defaultValue: false },
                { assign: "press", name: "Press Admin", value: false, defaultValue: false },
                { assign: 'general', name: 'General Admin', value: false, defaultValue: false },
                { assign: 'sundanceGuest', name: 'Sundance Guest Admin', value: false, defaultValue: false },
                { assign: "sioUser", name: "Industry User", value: false, defaultValue: false },
                { assign: "pressUser", name: "Press User", value: false, defaultValue: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest User', value: false, defaultValue: false },
                { assign: 'pafUser', name: 'PAF User', value: false, defaultValue: false },
            ],
            roleWiseFilterData: []
        }
    }

    componentDidMount() {
        let newRolesType = [...this.state.rolesType]
        newRolesType.forEach((item, i) => {
            if (this.props.user && this.props.user.additionalRoles.includes(item.assign)) {
                newRolesType[i].value = true
                newRolesType[i].defaultValue = true
            } else {
                newRolesType[i].value = false
            }
        })
        this.setState({rolesType: newRolesType, roleWiseFilterData:this.props.user.additionalRoles})
    }

     //role wise filter
     handleRole = (e, selectedInex) => {
        let event = e.target.checked
        let roleArray = [...this.state.rolesType]
        roleArray[selectedInex].value = event        
        this.setState({
            ...this.state,
            rolesType: roleArray,
            roleWiseFilterData: roleArray.filter(role => role.value).map(role => role.assign)
        }, () => {
        })
    };
    render() {
        const { rolesType, roleWiseFilterData } = this.state
        return (
            <div className='user_popup active role_reset_popup'>
            <span className="popup_overlay" onClick={this.props.closeRoleResetPopup}></span>
            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                <p className='text_center pt_25'>{this.props.admin ? 'Add / Remove Role' : 'Remove Role'}</p>
                <div className="approve_popup_header text_center relative">
                    <div className="customCheck">
                        {rolesType.map((item, i) => (
                            this.props.admin ? item.name.toLowerCase().includes('admin') : (!item.name.toLowerCase().includes('admin') && !item.name.toLowerCase().includes('paf') && item.defaultValue)) && (
                            <div className="customCheckBox">
                                <input
                                    type="checkbox"
                                    id={item.name+i}
                                    name={item.name}
                                    value={item.value ? true : false}
                                    checked={item.value ? true : false}
                                    onChange={(e) => this.handleRole(e, i)}
                                />
                                <label htmlFor={item.name+i}>{item.name}</label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="content">
                    <div className="field_row text_center">
                        <button className="active" onClick={() => this.props.updateRole(this.props.user, roleWiseFilterData)}>Update Role</button>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}